import React from 'react';
import Select from 'react-select';
import axios from 'axios';

import {
	getSession,
} from 'Vulture/Session';

import CustomIcon from '../Common/CustomIcon/CustomIcon.js';

import style from './Billing.module.css';

class BillingView extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			selectedProperty:     null,
			activeTab:            'billing information',
			projectNumbers:       [],
			projectNumbersLoaded: false,
			propertyInvoices:     [],
			fetchingError:        false,
			missingCustomerId:    false,
			formData:             {
				company_name: '',
				contact:      '',
				email:        '',
				phone:        '',
				addr1:        '',
				addr2:        '',
				city:         '',
				state:        '',
				zip:          '',
			},
			customerID:   '',
			customerName: '',
			errors:       {},
		};
	}

	componentDidMount() {
		if (this.props.fd && !this.state.projectNumbersLoaded) {
			this.getProjectNumbers();
		}
	}

	componentDidUpdate = (prevProps, prevState) => {
		if (prevState.selectedProperty !== this.state.selectedProperty) {
			this.getInvoices();
		}

		if (this.props.fd && prevProps.fd !== this.props.fd && !this.state.projectNumbersLoaded) {
			this.getProjectNumbers();
		}
	}

	getProjectNumbers = () => {
		// const url = new URL(window.location.href);
		// const segments = url.pathname.split('/');

		// const accountUUID = segments[segments.length - 1] || segments[segments.length - 2];

		// if (!accountUUID) {
		// 	console.error('Account UUID not found in the URL.');
		// 	return;
		// }

		const {
			fd,
			accountUUID,
			permissions,
		} = this.props;

		const account = fd[`account.${accountUUID}`];
		let projectNumbers = [];

		if (account) {
			for (const [ m1Key, m1Data, ] of Object.entries(account)) {
				if (m1Key.startsWith('system_group.')) {
					if (!permissions?.access_limits?.property_limited ||
						permissions.accessible_data.properties.includes(m1Key.replace('system_group.', ''))) {
						const projectNumber = fd[m1Key]?.project_number;
						if (projectNumber) {
							projectNumbers.push({
								projectNumber,
								systemGroupName: fd[m1Key].display_name,
							});
						}
					}
				}
			}

			this.setState({
				projectNumbers,
				projectNumbersLoaded: true,
			});
		} else {
			console.warn(`No account found for UUID: ${accountUUID}`);
		}
	}

	getBillingInformation = async (selectedProperty) => {
		const {
			app,
			fd,
		} = this.props;

		const session = getSession();
		let salesforceIdVal;

		for (const [ m1Key, m1Data, ] of Object.entries(fd)) {
			if (m1Key.startsWith('system_group.')) {
				if (m1Data.project_number === selectedProperty) {
					salesforceIdVal = m1Data.salesforce_id_val;
				}
			}
		}

		app.load(async () => {
			const broncoURL = window._getEnv('BRONCO_URL');

			const fetchBillingInformation = async (selectedProperty, id) => {
				try {
					const url = `${broncoURL}/system_group/${selectedProperty}/maxio`;
					const headers = {
						'X-Auth-Session': session.session,
					};

					const response = await axios.get(url, {
						headers,
					});
					const data = response.data;

					// Update formData with the fetched data
					this.setState({
						formData: {
							company_name: data.billing_profile.company_name || '',
							contact:      data.billing_profile.contact || '',
							email:        data.billing_profile.email || '',
							phone:        data.billing_profile.phone || '',
							addr1:        data.billing_profile.addr1 || '',
							addr2:        data.billing_profile.addr2 || '',
							city:         data.billing_profile.city || '',
							state:        data.billing_profile.state || '',
							zip:          data.billing_profile.zip || '',
						},
						customerID:   data.id,
						customerName: data.name,
						errors:       {},
					});
				} catch (err) {
					this.setState({
						formData: {
							company_name: '',
							contact:      '',
							email:        '',
							phone:        '',
							addr1:        '',
							addr2:        '',
							city:         '',
							state:        '',
							zip:          '',
						},
						customerID:   '',
						customerName: '',
						errors:       {},
					});
					console.error('Error fetching billing information:', err);
				}
			};

			await fetchBillingInformation(selectedProperty, salesforceIdVal);
		});
	}

	updateBillingInformation = async (selectedProperty) => {
		const {
			app,
		} = this.props;

		const session = getSession();
		const broncoURL = window._getEnv('BRONCO_URL');

		// Retrieve form data from state
		const {
			company_name,
			contact,
			email,
			phone,
			addr1,
			addr2,
			city,
			state,
			zip,
		} = this.state.formData;

		app.load(async () => {
			try {
				const url = `${broncoURL}/system_group/${selectedProperty}/maxio`;
				const headers = {
					'X-Auth-Session': session.session,
					'Content-Type':   'application/json',
				};

				const payload = {
					id:              Number(this.state.customerID),
					name:            this.state.customerName,
					billing_profile: {
						company_name,
						contact,
						email,
						phone,
						addr1,
						addr2,
						city,
						state,
						zip,
						salutation: selectedProperty,
					},
				};

				const response = await axios.patch(url, payload, {
					headers,
				});
				console.log('Billing information updated successfully:', response.data);
			} catch (err) {
				console.error('Error updating billing information:', err);
			}
		});
	};

	getInvoices = () => {
		const {
			app,
		} = this.props;

		app.load(async () => {
			const broncoURL = window._getEnv('BRONCO_URL');

			const fetchInvoiceInfomation = async (propertyNumber) => {
				const url = `${broncoURL}/system_group/${propertyNumber}/maxio/invoices`;
				const session = getSession();
				const headers = {
					'X-Auth-Session': session.session,
				};

				try {
					const response = await axios.get(url, {
						headers,
					});
					this.setState({
						propertyInvoices:  response.data,
						fetchingError:     false,
						missingCustomerId: false,
					});
				} catch (err) {
					let isMissingCustomerID = false;
					if (err.response.data === 'missing MAXIO_CUSTOMER_ID') {
						isMissingCustomerID = true;
					}
					this.setState({
						propertyInvoices:  [],
						fetchingError:     true,
						missingCustomerId: isMissingCustomerID,
					});
					console.error('Error fetching invoices:', err);
				}
			};

			await fetchInvoiceInfomation(this.state.selectedProperty);
		});
	}

	handleInputChange = (e) => {
		const {
			name,
			value,
		} = e.target;
		this.setState((prevState) => {
			return ({
				formData: {
					...prevState.formData,
					[name]: value,
				},
				errors: {
					...prevState.errors,
					[name]: '',
				},
			});
		});
	}

	validateForm = () => {
		const {
			company_name,
			contact,
			email,
			phone,
			addr1,
		} = this.state.formData;
		const errors = {};

		if (!company_name.trim()) {
			errors.company_name = 'Company is required.';
		}

		if (!contact.trim()) {
			errors.contact = 'Contact Name is required.';
		}

		if (!addr1.trim()) {
			errors.addr1 = 'Address Line 1 is required.';
		}

		if (email.trim()) {
			const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
			if (!emailRegex.test(email)) {
				errors.email = 'Please enter a valid email address.';
			}
		}

		if (phone.trim()) {
			// US phone number regex:
			// Allows formats like:
			// 1234567890
			// 123-456-7890
			// (123) 456-7890
			// 123.456.7890
			// +1 (123) 456-7890
			const phoneRegex = /^(\+1\s?)?(\([0-9]{3}\)|[0-9]{3})[-.\s]?[0-9]{3}[-.\s]?[0-9]{4}$/;
			if (!phoneRegex.test(phone.trim())) {
				errors.phone = 'Please enter a valid US phone number.';
			}
		} else {
			errors.phone = 'Phone number is required.';
		}

		this.setState({
			errors,
		});

		return Object.keys(errors).length === 0;
	}

	handleFormSubmit = (e) => {
		e.preventDefault();
		if (this.validateForm()) {
			this.updateBillingInformation(this.state.selectedProperty);
		} else {
			console.log('Form contains errors.');
		}
	}

	renderTab = () => {
		let tabHtml = null;
		let tabHtmlContent = null;
		if (this.state.activeTab === 'billing information') {
			tabHtmlContent = (
				<form onSubmit={this.handleFormSubmit} noValidate>
					{(this.state.fetchingError && this.state.missingCustomerId) && (
						<div>No customer information for this property.</div>
					)}
					<div className={`${style.form} text-small`}>
						<label>
							Company<span className={style.required}> *</span>
							<input
								type="text"
								name="company_name"
								value={this.state.formData.company_name}
								onChange={this.handleInputChange}
								className={this.state.errors.company_name ? style.inputError : ''}
							/>
							{this.state.errors.company_name && <p className={style.error}>{this.state.errors.company_name}</p>}
						</label>
						<label>
							Contact Name<span className={style.required}> *</span>
							<input
								type="text"
								name="contact"
								value={this.state.formData.contact}
								onChange={this.handleInputChange}
								className={this.state.errors.contact ? style.inputError : ''}
							/>
							{this.state.errors.contact && <p className={style.error}>{this.state.errors.contact}</p>}
						</label>
						<label>
							Email
							<input
								type="text"
								name="email"
								value={this.state.formData.email}
				                onChange={this.handleInputChange}
								className={this.state.errors.email ? style.inputError : ''}
							/>
							{this.state.errors.email && <p className={style.error}>{this.state.errors.email}</p>}
						</label>
						<label>
							Phone
							<input
								type="text"
								name="phone"
								value={this.state.formData.phone}
								onChange={this.handleInputChange}
								className={this.state.errors.phone ? style.inputError : ''}
							/>
							{this.state.errors.phone && <p className={style.error}>{this.state.errors.phone}</p>}
						</label>
						<label>
							Address Line 1<span className={style.required}> *</span>
							<input
								type="text"
								name="addr1"
								value={this.state.formData.addr1}
								onChange={this.handleInputChange}
								className={this.state.errors.addr1 ? style.inputError : ''}
							/>
							{this.state.errors.addr1 && <p className={style.error}>{this.state.errors.addr1}</p>}
						</label>
						<label>
							Address Line 2
							<input
								type="text"
								name="addr2"
								value={this.state.formData.addr2}
								onChange={this.handleInputChange}
							/>
						</label>
						<div className={style.cityStateLine}>
							<label>
								City
								<input
									type="text"
									name="city"
									value={this.state.formData.city}
									onChange={this.handleInputChange}
								/>
							</label>
							<label>
								State
								<input
									type="text"
									name="state"
					                value={this.state.formData.state}
									onChange={this.handleInputChange}
								/>
							</label>
						</div>
						<label>
							ZIP Code
							<input
								type="text"
								name="zip"
								value={this.state.formData.zip}
								onChange={this.handleInputChange}
							/>
						</label>
					</div>
					<button className="button" type="submit">Update Billing Information</button>
				</form>
			);
		} else {
			tabHtmlContent = (
				<>
					{this.state.fetchingError && (
						<div>There seems to be an issue retrieving your invoices. Please refresh or come back in a bit.</div>
					)}

					{(!this.state.propertyInvoices || this.state.propertyInvoices.length === 0) && !this.state.fetchingError && (
						<div>No invoices found.</div>
					)}
					<table className={style.table}>
						<thead>
							<tr>
								<th>Invoice Number</th>
								<th>Date</th>
								<th>Amount</th>
								<th>Status</th>
								<th>Action</th>
							</tr>
						</thead>
						<tbody>
							{this.state.propertyInvoices && this.state.propertyInvoices.map((invoice, index) => {
								return (
									<tr key={index}>
										<td>{invoice.number}</td>
										<td>{invoice.date}</td>
										<td>{invoice.local_amount}</td>
										<td>{invoice.is_paid ? 'Paid' : 'Not paid'}</td>
										<td>
											{invoice.einvoicing_url && (
												<button className={style.viewButton} onClick={() => {
													this.viewInvoice(invoice);
												}}>
													<CustomIcon icon='eye' color={'#4B4B4B'} /> View
												</button>
											)}
										</td>
									</tr>
								);
							})}
						</tbody>
					</table>
				</>
			);
		}

		tabHtml = (<div className={style.container}>
			<div className={style.tabContainer}>
				<button onClick={(() => {
					this.changeTab('billing information');
				})} className={`${style.tab} ${this.state.activeTab === 'billing information' && style.activeTab}`}>Billing Information</button>
				<button onClick={(() => {
					this.changeTab('invoices');
				})} className={`${style.tab} ${this.state.activeTab === 'invoices' && style.activeTab}`}>Invoices</button>
			</div>
			{tabHtmlContent}
		</div>);

		return tabHtml;
	}

	viewInvoice = (invoice) => {
		if (!invoice.einvoicing_url) {
			console.error('EInvoicing URL is not available for this invoice.');
			return;
		}

		window.open(invoice.einvoicing_url, '_blank');
	};

	changeTab = (tab) => {
		this.setState({
			activeTab: tab,
		});
	}

	render() {
		return (
			<React.Fragment>
				<div className={style.billingPage}>
					<div className='settings-header'>
						<h2>Billing Profile</h2>
					</div>
					<div className={style.billingContent} >
						<div className={style.label}>Property</div>
						<Select
							options={this.state.projectNumbers.map((project) => {
								return {
									value: project.projectNumber,
									label: `${project.projectNumber} - ${project.systemGroupName}`,
								};
							})}
							onChange={(e) => {
								this.setState({
									selectedProperty: e.value,
									errors:           { },
								});
								this.getInvoices();
								this.getBillingInformation(e.value);
							}}
						/>

						{!this.state.selectedProperty && (
							<div className={style.alertMessage}>
								Please select a property to view billing information and invoices.
							</div>
						)}

						{(this.state.selectedProperty) && (this.renderTab())}
					</div>
				</div>
			</React.Fragment>
		);
	}
}

window.CrowFormField['custom.vulture.billing'] = BillingView;
export default BillingView;
